module.exports = __webpack_public_path__ + "images/emoji/lantern.1e509a4ee942ea01f20a.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/lantern.png
// module id = ESb/
// module chunks = 24